import styled from 'styled-components';
import Bee from './BeeFileManager';

export const BeeFileManager = styled(Bee)`
  width: 100%;
  height: 100%;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: hidden;
  height: 90vh;
  position: relative;
`;

export const FullScreenContainer = styled.div`
  width: 100%;
  overflow: hidden;
  height: 100%;
  position: relative;
`;
